import { fetcher } from '@commenda/utils';
import { TExecuteTrueUpBody, TExecuteTrueUpResponse } from './types';

export async function executeTrueUp(
  body: TExecuteTrueUpBody
): Promise<TExecuteTrueUpResponse> {
  const response = await fetcher('tp-true-up/execute', {
    method: 'POST',
    body,
  });
  if (!response.ok) throw new Error('Failed to execute true-up');
  return (await response.json()) as TExecuteTrueUpResponse;
}
